import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { RadioIcon } from "@nike/nike-design-system-icons";
import classNames from "classnames";
export const Radio = ({ checked, disabled, id, label, name, onChange, value, className, ...rest }) => {
    const [isChecked, setIsChecked] = useState(!!checked);
    // used to make a controlled component
    useEffect(() => {
        setIsChecked(!!checked);
    }, [checked]);
    const handleChange = (event) => {
        if (disabled !== true) {
            setIsChecked(!isChecked);
            if (onChange)
                onChange(event);
        }
    };
    return (_jsxs("label", { htmlFor: id, className: classNames(className, `eds-radio`, {
            "eds-radio--disabled": disabled,
        }), style: typeof label !== "string" ? { alignItems: "start" } : null, children: [_jsx("input", { type: "radio", name: name, id: id, value: value || id, checked: checked, disabled: !!disabled, onChange: handleChange, className: "eds-radio__input", ...rest }), _jsx("span", { className: "eds-radio__animation" }), _jsx(RadioIcon, { "aria-hidden": true }), label] }));
};
